import React from 'lib/react';
import { EVTypography } from 'lib/components';
import MapDisclaimerStyles from './MapDisclaimerStyles';

function MapDisclaimer() {
  const classes = MapDisclaimerStyles();
  return (
    <EVTypography className={classes.disclaimer} id="map-disclaimer">
      <span>
        © 2025 TomTom, Earthstar Geographics SIO, © 2025 Microsoft Corporation, ©
        {' '}
        <a target="_blank" href="https://www.openstreetmap.org/copyright" rel="noreferrer">OpenStreetMap</a>
        {' '}
        <a target="_blank" href="https://www.microsoft.com/maps/assets/docs/terms.aspx" rel="noreferrer">Terms</a>
      </span>
      Images provided by Bing Maps are for property identification purposes only and are not a
      representation of EagleView images or the availability of images for the property.
    </EVTypography>
  );
}

export default MapDisclaimer;
